"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeList = void 0;
const react_1 = __importDefault(require("react"));
const _ui_1 = require("@ui");
const util_1 = require("@app/util");
const i18n_1 = require("@app/util/i18n");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function EmployeeList({ employees, onRemove, canBeRemoved = () => Boolean(onRemove), onSelectChange, selected, withSearch = false, }) {
    const [searchValue, setSearchValue] = react_1.default.useState('');
    const filteredEmployees = react_1.default.useMemo(() => {
        if (!withSearch)
            return employees;
        const normalizedValue = searchValue
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
        return employees.filter((employee) => {
            const normalizedName = employee.name
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
            const nameChunks = normalizedName.split(' ');
            const normalizedNameReversed = nameChunks.reverse().join(' ');
            return (normalizedName.startsWith(normalizedValue) ||
                normalizedNameReversed.startsWith(normalizedValue) ||
                nameChunks.some((chunk) => chunk.startsWith(normalizedValue)));
        });
    }, [employees, searchValue]);
    return (react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN },
        withSearch ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(_ui_1.Input, { value: searchValue, onChange: setSearchValue, placeholder: (0, maybe_unwrap_1.unwrapMaybe)((0, i18n_1.t)('SEARCH')), size: _ui_1.Input.SIZES.FULL_WIDTH, ico: 'search' }),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_12 }))) : (false),
        filteredEmployees.map((employee, index) => {
            return (react_1.default.createElement(react_1.default.Fragment, { key: employee.id },
                react_1.default.createElement(_ui_1.Flex, { testid: `employee-list-item-${employee.id}`, align: _ui_1.Flex.POSITION.CENTER, justify: _ui_1.Flex.POSITION.SPC_BETWEEN, grow: 1 },
                    react_1.default.createElement("div", { onClick: onSelectChange
                            ? () => {
                                onSelectChange(employee);
                            }
                            : undefined },
                        react_1.default.createElement(_ui_1.Flex, { align: 'center' },
                            onSelectChange ? (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(_ui_1.Checkbox, { checked: selected?.includes(employee.id) }),
                                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_12 }))) : (false),
                            react_1.default.createElement(_ui_1.Avatar, { size: 24, profile: employee.name ? employee : undefined }),
                            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_8 }),
                            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE }, employee.name
                                ? employee.name
                                : util_1.miscUtil.getEnforcedLocality()
                                    ? (0, i18n_1.t)('POS_OTHER_LOC_EMP')
                                    : (0, i18n_1.t)('POS_EXTERNAL_EMP')))),
                    onRemove && canBeRemoved(employee) && (react_1.default.createElement(_ui_1.Icon, { testid: 'remove-employee-icon', ico: _ui_1.Icon.ICONS.close1, color: _ui_1.Icon.COLORS.RED, size: _ui_1.Icon.SIZES.SMALL, onClick: () => onRemove(employee) }))),
                index + 1 < filteredEmployees.length && (react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8 }))));
        })));
}
exports.EmployeeList = EmployeeList;
